import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fromReservation } from 'store/selectors';

import { GuestListEntry } from 'components';

const GuestListEntryContainer = props => <GuestListEntry {...props} />;

const mapStateToProps = (state, { id }) => {
  const { expanded } = fromReservation.getGuest(state, id);
  return {
    expanded,
  };
};
GuestListEntryContainer.propTypes = {
  id: PropTypes.string.isRequired,
};

export default connect(mapStateToProps)(GuestListEntryContainer);



// WEBPACK FOOTER //
// ./src/containers/GuestListEntry.js